import { render, staticRenderFns } from "./ManterHistoricoDeFormacao.vue?vue&type=template&id=6cb55624"
import script from "./ManterHistoricoDeFormacao.vue?vue&type=script&lang=js"
export * from "./ManterHistoricoDeFormacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports